// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__iaPUb","slider":"styles_slider__MkWHP"};